// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import ArtisticAIPolicy from './ArtisticAIPolicy';
import PersonAlertAIPolicy from './PersonAlertAIPolicy';
import PawAlertAIPolicy from './PawAlertAIPolicy';
import ArtisticAIIcon from './assets/artistic-ai-icon.png';
import PersonAlertAIIcon from './assets/personalert-ai-icon.png';
import PawAlertAIIcon from './assets/pawalert-ai-icon.png';
import WallifyIcon from './assets/wallify-icon.png';
import WallifyIntegrityPolicy from './WallifyPolicy';


function App() {
  return (
    <Router>
      <div className="App">
        <nav>
          <ul className="nav-list">
            <li>
              <Link to="/artistic-ai-policy" className="nav-link" aria-label="Artistic AI Policy">
                <img src={ArtisticAIIcon} alt="Artistic AI Icon" className="nav-icon" />
                Artistic AI Policy
              </Link>
            </li>
            <li>
              <Link to="/personalert-ai-policy" className="nav-link" aria-label="PersonAlert AI Policy">
                <img src={PersonAlertAIIcon} alt="PersonAlert AI Icon" className="nav-icon" />
                PersonAlert AI Policy
              </Link>
            </li>
            <li>
              <Link to="/wallify-policy" className="nav-link" aria-label="PawAlert AI Policy">
                <img src={WallifyIcon} alt="PawAlert AI Icon" className="nav-icon" />
                Wallify Policy
              </Link>
            </li>
          </ul>
        </nav>

        <Routes>
          <Route path="/" element={<ArtisticAIPolicy />} />
          <Route path="/artistic-ai-policy" element={<ArtisticAIPolicy />} />
          <Route path="/personalert-ai-policy" element={<PersonAlertAIPolicy />} />
          <Route path="/pawalert-ai-policy" element={<PawAlertAIPolicy />} />
          <Route path="/wallify-policy" element={<WallifyIntegrityPolicy />} />
          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

// NotFound Component
function NotFound() {
  return (
    <div className="App">
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <Link to="/">Go to Artistic AI Policy</Link>
    </div>
  );
}

export default App;
